import { useState, useEffect } from 'react'
import Modal from './Modal'
import { useI18n } from '../i18n'

export default function ConnectModal({ open, mode = 'edit', model, onCancel, onSave }) {
  const { t } = useI18n()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isTest, setIsTest] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!open) return
    if (mode === 'edit' && model) {
      setEmail(model.of_email ?? '')
      setIsTest(model.is_test ?? false)
    } else if (mode === 'create') {
      setEmail('')
      setIsTest(false)
    }
    setPassword('')
    setError('')
  }, [open, mode, model?.id, model?.of_email, model?.is_test])

  function getCredentials() {
    if (!email.trim() && !isTest) return null
    if (mode === 'create' && !password.trim() && !isTest) return null

    return {
      email: email.trim() || (isTest ? `test-${Date.now()}@example.com` : ''),
      password: password.trim() || (isTest ? 'test_pass' : undefined),
      is_test: isTest,
    }
  }

  async function handleSubmit(e) {
    e.preventDefault()
    const isCreate = mode === 'create'
    const creds = getCredentials()
    if (!creds) {
      setError(isCreate ? t('models.connectModal.validationRequiredCreate') : t('models.connectModal.validationRequiredEdit'))
      return
    }
    setSubmitting(true)
    setError('')
    try {
      const result = onSave?.(creds)
      await (result && typeof result.then === 'function' ? result : Promise.resolve(result))
      onCancel?.()
    } catch (err) {
      setError(err?.message || t('common.error'))
    } finally {
      setSubmitting(false)
    }
  }

  const isCreate = mode === 'create'
  const passwordPlaceholder = isCreate ? '••••••••' : t('models.connectModal.passwordUnchangedPlaceholder')

  return (
    <Modal
      open={open}
      title={isCreate ? t('models.connectModal.titleCreate') : t('models.connectModal.titleEdit')}
      titleId="connect-modal-title"
      onClose={onCancel}
      footer={
        <div className="modal-actions modal-actions--center">
          <button
            type="submit"
            form="connect-modal-form"
            className="modal-btn modal-btn-primary"
            disabled={submitting}
          >
            {submitting ? t('common.saving') : t('common.save')}
          </button>
        </div>
      }
    >
      <form id="connect-modal-form" onSubmit={handleSubmit} className="modal-form">
        {error && <div className="modal-error">{error}</div>}
        <label>
          Email (OnlyFans)
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="email@example.com"
            autoComplete="off"
          />
        </label>
        <label>
          {t('models.connectModal.password')}
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={passwordPlaceholder}
            autoComplete={isCreate ? 'new-password' : 'off'}
          />
        </label>
        {isCreate && (
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginTop: '10px' }}>
            <input
              type="checkbox"
              checked={isTest}
              onChange={(e) => setIsTest(e.target.checked)}
            />
            <span>{t('models.connectModal.testModel')}</span>
          </label>
        )}
      </form>
    </Modal>
  )
}
